// removed by extract-text-webpack-plugin
module.exports = {"product-info":"_1HTb","input-list":"_1otA","payBtn":"_1i0a"};


//////////////////
// WEBPACK FOOTER
// ./form/components/paymentfields/style.css
// module id = VHod
// module chunks = 4